// Fonte unica per i tipi di assenza: aggiungere un nuovo tipo qui e in
// ABSENCE_COLORS basta perché calendari, statistiche e PDF lo riconoscano.
export const ABSENCE_TYPES = ['ferie', 'permesso', 'malattia', 'infortunio'];

const ABSENCE_COLORS = { ferie: 'green', permesso: 'yellow', malattia: 'red', infortunio: 'teal' };

export const isAbsence = (type) => ABSENCE_TYPES.includes(type);

// Case-insensitive: le richieste ferie arrivano anche come "Infortunio"
export const absenceColor = (type, fallback = 'green') =>
  ABSENCE_COLORS[String(type || '').toLowerCase()] || fallback;

// Il backend restituisce "0" per le note vuote
export const cleanNotes = (notes) =>
  (notes && String(notes).trim() !== '' && String(notes) !== '0' ? notes : '');
